import { IEnrollableCoursesResponse } from '@/types/views/enrollment.types';
import { useAppQuery } from './useAppQuery';

export const useGetEnrollableCourses = () => {
  return useAppQuery<IEnrollableCoursesResponse>('/TrainingManager/enrolment-courses', {
    // Own-portal rows are opt-in so an older bundle never mistakes them for free catalogue courses.
    config: { params: { includeOwnPortal: true } },
  });
};
